import { FileCheck2, CalendarClock, Home } from "lucide-react";

const HIGHLIGHTS = [
  {
    icon: FileCheck2,
    title: "Easy Application",
    desc: "A streamlined online application designed to save you time.",
    testid: "highlight-easy-application",
  },
  {
    icon: CalendarClock,
    title: "Funding as soon as 5 days*",
    desc: "Fast funding for qualified borrowers with documentation ready.",
    testid: "highlight-funding",
  },
  {
    icon: Home,
    title: "Keep Your Low First Mortgage**",
    desc: "A HELOC may allow you to access equity without refinancing.",
    testid: "highlight-keep-mortgage",
  },
];

export default function HighlightsBar() {
  return (
    <section
      data-testid="highlights-section"
      aria-label="HELOC highlights"
      className="relative z-10 -mt-16 md:-mt-24 lg:-mt-28 px-4 sm:px-6 lg:px-8"
    >
      <div className="max-w-7xl mx-auto">
        <div className="bg-white border border-[#E2E8F0] rounded-xl shadow-xl grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-[#E2E8F0] overflow-hidden">
          {HIGHLIGHTS.map(({ icon: Icon, title, desc, testid }) => (
            <div key={title} data-testid={testid} className="p-6 md:p-8 flex items-start gap-4">
              <div className="shrink-0 w-12 h-12 rounded-md bg-[#0A2F6B] flex items-center justify-center">
                <Icon size={22} className="text-[#F26A21]" strokeWidth={2.5} />
              </div>
              <div>
                <h3 className="font-display font-bold text-[#0A2F6B] text-lg leading-tight">
                  {title}
                </h3>
                <p className="text-sm text-[#475569] mt-1.5 leading-relaxed">{desc}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="text-[11px] text-[#94A3B8] mt-3 px-1">
          * Timing may vary based on borrower qualifications and documentation requirements.
          ** A HELOC may allow eligible homeowners to access equity without refinancing their existing first mortgage.
        </p>
      </div>
    </section>
  );
}
